"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const svg_components_1 = require("@/assets/svg-components");
const Types_1 = require("Types");
const Theme_1 = require("app/Theme");
const ProductLogo = ({ manufacturer }) => {
    const isDesktopSmall = window.innerWidth <= Theme_1.theme.breakpoints.lg;
    switch (manufacturer) {
        case Types_1.Manufacturers.HALDEX:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.HaldexLogo, null) : react_1.default.createElement(svg_components_1.HaldexLogoLarge, null);
        case Types_1.Manufacturers.GRAU:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.GrauLogo, null) : react_1.default.createElement(svg_components_1.GrauLogoLarge, null);
        case Types_1.Manufacturers.LIKE_NU:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.LikeNuLogo, null) : react_1.default.createElement(svg_components_1.LikeNuLogoLarge, null);
        case Types_1.Manufacturers.LIKENU:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.LikeNuLogo, null) : react_1.default.createElement(svg_components_1.LikeNuLogoLarge, null);
        case Types_1.Manufacturers.MIDLAND:
            return react_1.default.createElement(svg_components_1.MidlandLogo, null);
        case Types_1.Manufacturers.GUNITE:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.GuniteLogo, null) : react_1.default.createElement(svg_components_1.GuniteLogoLarge, null);
        case Types_1.Manufacturers.REMAN:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.RemanLogo, null) : react_1.default.createElement(svg_components_1.RemanLogoLarge, null);
        default:
            return isDesktopSmall ? react_1.default.createElement(svg_components_1.HaldexLogo, null) : react_1.default.createElement(svg_components_1.HaldexLogoLarge, null);
    }
};
exports.default = ProductLogo;
